import React, { useRef } from 'react'
import Image from "next/image"
import Link from "next/link"

import Call from "/public/hire/call.webp"
import Email from "/public/hire/email.webp"
import Logo from "/public/hire/footerlogo.webp"
import Playstore from "/public/hire/playstore.webp"
import Rightarrow from "/public/hire/rightarrow.webp"

interface Iprops {
	quicklinks: typeof Object,
	jobs: typeof Object,
	locations: typeof Object
}

export default function Footer({ quicklinks, jobs, locations }: Iprops) {


	return (
		<footer>
			<div className="foot-main">
				<div className="space-y-[24px] col-span-1">
					<Image
						src={Logo}
						className={"w-auto h-[22px]"}
						width={0}
						height={0}
						alt={""}
					/>
					<p className="leading-[23px] text-[14px] font-normal text-[#323232] w-[90%] mb-[0px]">
						With 45M+ downloads, Lokal is a one stop solution for local updates,
						job search, classifieds and more!.{" "}
					</p>
					<Link href={"https://play.google.com/store/apps/details?id=get.lokal.localnews&pli=1"}>
					<Image
						src={Playstore}
						className={"w-auto h-[60px] mt-[24px]"}
						width={0}
						height={0}
						alt={""}
					/>
					</Link>

				</div>
				<div
					className={
						"col-span-1 grid grid-cols-1 md:grid-cols-3 md:gap-x-[64px] gap-y-[24px] md:gap-y-[0px]"
					}
				>
					<div className="space-y-[16px] col-span-1">
						<h5>Quick Links</h5>
						<ul className="list-none">
							<li >
								<Link scroll={false} href={"#banner-section"}>Post a Job</Link>
							</li>
							<li>
								<Link target='_parent'
									rel="noopener noreferrer" scroll={false} href={"/jobs/jobs-near-me"}>Find a job</Link>
							</li>
							<li>
								<Link scroll={false} href={"#banner-section"}>Create an account</Link>
							</li>
						</ul>
					</div>
					<div className="space-y-[16px] col-span-1">
						<h5>Jobs by category</h5>
						<ul className="list-none">
							{
								Object.values(jobs).map((val: any, index: number) => {
									

									return <li className={`${index}-top-jobs`}>
										<Link scroll={false} href="#banner-section">{val.english_name}</Link>
									</li>

								})
							}
							<li>
								<Link scroll={false} className={"sublink"} href={{ pathname: '/sitemap', query: { elementTitle: "Jobs by category" } }}
									as="/jobs/sitemap">
									<span>View all Roles</span>
									<Image
										src={Rightarrow}
										className={"w-auto h-[14px]"}
										width={0}
										height={0}
										alt={""}
									/>
								</Link>
							</li>
						</ul>
					</div>
					<div className="space-y-[16px] col-span-1">
						<h5>Jobs by location</h5>
						<ul className="list-none">
							{
								Object.values(locations).map((val: any, index: number) => {

									return <li className={`${index}-top-jobs`}>
										<Link scroll={false} href="#banner-section">{val.short_name}</Link>
									</li>

								})
							}
							<li>
								<Link scroll={false} className={"sublink"} href={{ pathname: '/sitemap', query: { elementTitle: 'Jobs by location' } }}
									as="/jobs/sitemap">
									<span>View all locations</span>
									<Image
										src={Rightarrow}
										className={"w-auto h-[14px]"}
										width={0}
										height={0}
										alt={""}
									/>
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div className={"foot-noteM md:foot-note"}>
				<ul className="md:col-span-2 lg:col-span-3 flex flex-wrap flex-col md:flex-row md:flex-nowrap justify-between items-start md:items-center lg:gap-x-[40px] md:gap-x-[6px] gap-y-[16px] list-none">
					{/* <li>
						<Link href="#">Customer services</Link>
					</li> */}
					<li>
						<Link target={`_blank`} href="mailto:support@getlokalapp.com">Email us</Link>
					</li>
					<li>
						<Link target={`_blank`} href="https://www.getlokalapp.com/privacy-policy/">Privacy Policy</Link>
					</li>
					<li>
						<Link target={`_blank`} href="https://getlokalapp.com/terms-conditions/">Terms & conditions</Link>
					</li>
					{/* <li>
						<Link href="#">© 2024 Lokal</Link>
					</li> */}
				</ul>
				<ul className="md:col-span-2 lg:col-span-2 md:flex justify-between items-center lg:gap-x-[40px] md:gap-x-[20px] hidden ">
					{/* <Link
						className={"items-center flex space-x-[8px] cursor-pointer no-underline text-[#666666]"}
						href={"tel:+91999990000"}
					>
						<Image
							src={Call}
							className={"w-[16px] h-[16px]"}
							width={0}
							height={0}
							alt={""}
						/>
						<p className="mb-[0px]">+91 999990000</p>
					</Link> */}

					<Link
						target={`_blank`}
						className={"items-center flex space-x-[8px] cursor-pointer no-underline text-[#666666]"}
						href={"mailto:support@getlokalapp.com"}
					>
						<Image
							src={Email}
							className={"w-[16px] h-[16px]"}
							width={0}
							height={0}
							alt={""}
						/>
						<p className="mb-[0px]">support@getlokalapp.com</p>
					</Link>
				</ul>
			</div>
		</footer>
	)
}
